import { c as _c } from "react/compiler-runtime";
import { CouponsListResponse } from '@/api/skippay/couponsList';
import { UseInfiniteQueryResult, InfiniteData } from '@tanstack/react-query';
import { Coupon, CouponSkeleton } from './Coupon';
import { Button } from '@/components/buttons';
import IconDown from '@/assets/icons/heroIcons/Chevron-down.svg';
import { useTranslation } from 'react-i18next';
import { NoResults } from './NoResults';
import { Category } from './functions/getCategories';
interface Props {
  query: UseInfiniteQueryResult<InfiniteData<CouponsListResponse | undefined, unknown>, Error>;
  emptyCategories: Category[];
  loadMoreLimit?: number;
}
export function SearchResults(props) {
  const $ = _c(19);
  const {
    query
  } = props;
  const {
    t
  } = useTranslation("discounts");
  if (query.isLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="mt-4 grid auto-rows-auto grid-cols-2 gap-4 lg:mt-8 lg:grid-cols-4 lg:gap-8"><CouponSkeleton /><CouponSkeleton /><CouponSkeleton /><CouponSkeleton /></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (!query.data) {
    return null;
  }
  if (query.data.pages[0]?.data.length === 0) {
    let t0;
    if ($[1] !== props.emptyCategories) {
      t0 = <NoResults emptyCategories={props.emptyCategories} />;
      $[1] = props.emptyCategories;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  if (query.isError) {
    let t0;
    if ($[3] !== t) {
      t0 = t("search.error");
      $[3] = t;
      $[4] = t0;
    } else {
      t0 = $[4];
    }
    let t1;
    if ($[5] !== t0) {
      t1 = <div className="py-20 text-center text-xl text-gray-500">{t0}</div>;
      $[5] = t0;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  let t0;
  if ($[7] !== query.data.pages) {
    t0 = query.data.pages.map(_temp2);
    $[7] = query.data.pages;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  let t1;
  if ($[9] !== props.loadMoreLimit || $[10] !== query.data.pages.length || $[11] !== query.fetchNextPage || $[12] !== query.hasNextPage || $[13] !== query.isFetchingNextPage || $[14] !== t) {
    t1 = query.hasNextPage && (props.loadMoreLimit !== undefined ? query.data.pages.length < props.loadMoreLimit : true) && <Button variant="secondary" analyticsParam="couponsLoadMore" testId="couponsLoadMore" onClick={query.fetchNextPage} className="mt-8 lg:mt-12" rightIcon={<IconDown />} align="center" busy={query.isFetchingNextPage}>{t("search.loadMore")}</Button>;
    $[9] = props.loadMoreLimit;
    $[10] = query.data.pages.length;
    $[11] = query.fetchNextPage;
    $[12] = query.hasNextPage;
    $[13] = query.isFetchingNextPage;
    $[14] = t;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  let t2;
  if ($[16] !== t0 || $[17] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[16] = t0;
    $[17] = t1;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  return t2;
}
function _temp2(page, pageIndex) {
  return <div className="mt-4 grid auto-rows-auto grid-cols-2 gap-4 lg:mt-8 lg:grid-cols-4 lg:gap-8" key={pageIndex}>{page?.data.map(_temp)}</div>;
}
function _temp(coupon, index) {
  return <Coupon key={coupon.id} index={index} data={coupon as NonNullable<CouponsListResponse>['data'][number]} />;
}